export enum UserRole {
  admin = 0,
  warehouse_worker = 1,
  client = 3
}
